import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-anuradha',
  templateUrl: './anuradha.component.html',
  styleUrls: ['./anuradha.component.scss']
})
export class AnuradhaComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getAnuradha();
  }
}
